import React from 'react'
import { Container, Typography } from '@material-ui/core'
import { List, ListItem, ListItemText } from '@mui/material'
import makeStyles from './style'
import solucoes from '../images/solucoes.jpeg'


export default function Solucoes() {
    const {bigContainer, container, title, description, rowColImg, solImg} = makeStyles()

    const eqp = ['Tornos conv./CNC', 'Fresadorsa conv./CNC', 'Geradora de engrenagens', 'Chaveteiras', 'Retíficas inter./cilindrica', 'C.U. vert./horizontal CNC', 'Prensas','Outras']
    const eqpqa = ['Paquímentros conv./digitais', 'Micrômetros', 'Calibradores tampão/eixos', 'Altímetros', 'Blocos-padrão', 'Durômetros', 'Comparadores', 'Outros']

    return (
        <Container className={bigContainer}>
            <Container className={container}>
                <Typography gutterBottom variant='h3' component='div' className={title}>
                Sempre a melhor solução
                </Typography>
                <Typography gutterBottom variant='h4' component='div' className={title}>
                Estruturada para melhor atendê-lo
                </Typography>
                <Typography variant='body2' color='text.secondary' className={description}>
                Oferecemos os mais variados serviços e com o mais alto padrão de qualidade de execusão de usinagem e industrialização de peças. Nossos serviços incluem tornearia, fresamento, retifica, mandrilhamento, abertura de dentes para engrenagens e outros. Consulte-nos.
                </Typography>
            </Container>
            <Container className={container}>
                <Typography gutterBottom variant='h4' component='div' className={title}>
                Nossos equipamentos
                </Typography>
                <Typography gutterBottom variant='h5' component='div' className={title}>
                Equipamentos para usinagem
                </Typography>
                <Typography variant='body2' color='text.secondary' className={description}>
                A M A disponibiliza para seus clientes maquinários modernos e bem conservados, nossos equipamentos são constantemente revisados, regulados e aferidos para garantir a máxima qualidade em nossos produtos. Os equipamentos disponíveis são: 
                <Container className={rowColImg}>
                    <List>
                        <li>
                        <ul>
                            {eqp.map((item, index) => (
                            <ListItem key={index}>
                                <ListItemText primary={item} />
                            </ListItem>
                            ))}
                        </ul>
                        </li>
                    </List>
                    <img src={solucoes} 
                    className={solImg}
                    alt='Logo Fates' />
                </Container>
                </Typography>
            </Container>
            <Container className={container}>
                <Typography gutterBottom variant='h5' component='div' className={title}>
                Equipamentos de controle de qualidade
                </Typography>
                <Typography variant='body2' color='text.secondary' className={description}>
                O controle de qualidade é a base para todo nosso sistema de produção. Um diversificado leque de equipamentos de medição garantem as medidas exigidas nos desenhos de nossos clientes. Periódicas e rigorosas calibrações e verificações nos equipamentos de medição garantem a precisão necessária ao processo produtivo. Os equipamentos disponíveis são: 
                A M A disponibiliza para seus clientes maquinários modernos e bem conservados, nossos equipamentos são constantemente revisados, regulados e aferidos para garantir a máxima qualidade em nossos produtos. Os equipamentos disponíveis são: 
                    <List>
                        <li>
                        <ul>
                            {eqpqa.map((item, index) => (
                            <ListItem key={index}>
                                <ListItemText primary={item} />
                            </ListItem>
                            ))}
                        </ul>
                        </li>
                    </List>
                </Typography>
            </Container>
        </Container>
    )
}